import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { FEATURE_KEYS } from '@src/configs/featureKeys';
import { DEFAULT_TOP_PAID_EVENT_IMAGES } from '@src/constants/topPaidEvent';
import {
  isDetailPageOpen,
  isEventRunning,
  normalizeEventConfig,
} from '@src/services/topPaidEvent';
import useFeatureFlags from './useFeatureFlags';

const useTopPaidEvent = () => {
  const user = useSelector((state) => state.auth.user);
  const { getFeatureValue } = useFeatureFlags();

  const rawConfig = getFeatureValue(FEATURE_KEYS.TOP_PAID_EVENT, {
    userId: user?.id,
    email: user?.email,
    phoneNumber: user?.phoneNumber,
  });

  const config = useMemo(
    () => normalizeEventConfig(rawConfig, DEFAULT_TOP_PAID_EVENT_IMAGES),
    [rawConfig],
  );

  const now = Date.now();

  return {
    config,
    isRunning: isEventRunning(config, now),
    isDetailPageOpen: isDetailPageOpen(config, now),
  };
};

export default useTopPaidEvent;
